export default __webpack_public_path__ + "static/media/img_post6.6523b0b7.png";